/* eslint-disable */
import React from 'react';
import {
  ICON_SETS,
  type AttackerTargetGridVariant,
} from './cardIcons';
import './index.less';

export type AttackerTargetGridLayout = 'with-intro' | 'cards-only';

export interface IAttackerTargetItem {
  text?: string;
  backgroundImage?: string;
}

export interface IAttackerTargetGridProps {
  title?: string;
  description?: string;
  items?: IAttackerTargetItem[];
  layout?: AttackerTargetGridLayout;
  variant?: AttackerTargetGridVariant;
}

const AttackerTargetGrid: React.FunctionComponent<IAttackerTargetGridProps> = ({
  title,
  description,
  items = [],
  layout = 'with-intro',
  variant = 'attacker-target',
}) => {
  const icons = ICON_SETS[variant];

  if (!items.length) return null;

  const renderCard = (item: IAttackerTargetItem, index: number) => {
    const Icon = icons[index % icons.length];
    const cardStyle = item.backgroundImage
      ? ({
          '--attacker-target-card-bg': `url(${item.backgroundImage})`,
        } as React.CSSProperties)
      : undefined;

    return (
      <div
        key={index}
        className="attacker-target-grid-card"
        style={cardStyle}
      >
        <div className="attacker-target-grid-card-icon">{Icon()}</div>
        <p className="attacker-target-grid-card-text">{item.text}</p>
      </div>
    );
  };

  if (layout === 'cards-only') {
    return (
      <div className="attacker-target-grid attacker-target-grid--cards-only">
        {title && (
          <h2 className="attacker-target-grid-title attacker-target-grid-title--standalone">
            {title}
          </h2>
        )}
        {description && (
          <p className="attacker-target-grid-desc attacker-target-grid-desc--standalone">
            {description}
          </p>
        )}
        <div className="attacker-target-grid-body">
          {items.map((item, index) => renderCard(item, index))}
        </div>
      </div>
    );
  }

  return (
    <div className="attacker-target-grid attacker-target-grid--with-intro">
      <div className="attacker-target-grid-intro">
        {title && <h2 className="attacker-target-grid-title">{title}</h2>}
        {description && (
          <p className="attacker-target-grid-desc">{description}</p>
        )}
      </div>
      {items.map((item, index) => renderCard(item, index))}
    </div>
  );
};

export default React.memo(AttackerTargetGrid);
